import { lazy } from 'react';

// Manage and Administrator
const CreateNewPage = lazy(() => import('src/pages/dashboard/news/create'));
const ListNewPage = lazy(() => import('src/pages/dashboard/news/list'));
const UserProfilePage = lazy(() => import('src/pages/dashboard/manage/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/manage/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/manage/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/manage/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/manage/user/new'));
const UserCreateExcelPage = lazy(() => import('src/pages/dashboard/manage/user/excel'));
const UserGroups = lazy(() => import('src/pages/dashboard/manage/user/group'));
const UserAreas = lazy(() => import('src/pages/dashboard/manage/user/areas'));
const UserDepartment = lazy(() => import('src/pages/dashboard/manage/user/department'));
const UserPosition = lazy(() => import('src/pages/dashboard/manage/user/position'));
const UserEditPage = lazy(() => import('src/pages/dashboard/manage/user/edit'));
const CourseMangePage = lazy(() => import('src/pages/dashboard/administrators/courseManage'));
const CourseMangeTablePage = lazy(
  () => import('src/pages/dashboard/administrators/courseManage/courseTable')
);
const CourseNewPage = lazy(() => import('src/pages/dashboard/administrators/courseManage/new'));
const AssignmentListPage = lazy(
  () => import('src/pages/dashboard/administrators/courseManage/assignmentList')
);
const AddChildCourse = lazy(
  () => import('src/pages/dashboard/administrators/courseManage/addChildCourse')
);
const AddUserToCourse = lazy(
  () => import('src/pages/dashboard/administrators/courseManage/addUserToCourse')
);
const CategoryCoursePage = lazy(
  () => import('src/pages/dashboard/administrators/courseManage/category')
);
const ContributionManagePage = lazy(
  () => import('src/pages/dashboard/administrators/courseManage/contribution')
);
const OrderManagePage = lazy(() => import('src/pages/dashboard/administrators/orderManage/list'));
const ExamListPage = lazy(() => import('src/pages/dashboard/manage/questions/exams/list'));
const ExamNewPage = lazy(() => import('src/pages/dashboard/manage/questions/exams/create'));
const QuestionListPage = lazy(() => import('src/pages/dashboard/manage/questions/questions/list'));
const QuestionNewPage = lazy(() => import('src/pages/dashboard/manage/questions/questions/create'));
const GroupsListPage = lazy(() => import('src/pages/dashboard/manage/questions/groups/list'));
const GroupNewPage = lazy(() => import('src/pages/dashboard/manage/questions/groups/create'));
const CreateQuestionByExcel = lazy(
  () => import('src/pages/dashboard/manage/questions/groups/excel')
);
const SurveyListPage = lazy(() => import('src/pages/dashboard/manage/questions/surveys/list'));
const SurveyNewPage = lazy(() => import('src/pages/dashboard/manage/questions/surveys/create'));
const EmailViewPage = lazy(() => import('src/pages/dashboard/manage/emails/view'));
const EmailTemplateViewPage = lazy(() => import('src/pages/dashboard/manage/emails/template'));
const NotifyViewPage = lazy(() => import('src/pages/dashboard/manage/notify/list'));
const NotifyNewPage = lazy(() => import('src/pages/dashboard/manage/notify/create'));
const CertificateViewPage = lazy(() => import('src/pages/dashboard/manage/certificate/list'));
const CertificateNewPage = lazy(() => import('src/pages/dashboard/manage/certificate/create'));
const ScheduleViewPage = lazy(() => import('src/pages/dashboard/manage/calendar/schedule/list'));
const ScheduleNewPage = lazy(() => import('src/pages/dashboard/manage/calendar/schedule/create'));
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));
const NotifyPage = lazy(() => import('src/pages/dashboard/notification'));
const SystemAccessPage = lazy(
  () => import('src/pages/dashboard/administrators/extends/systemAccess')
);
const SystemLogsPage = lazy(() => import('src/pages/dashboard/administrators/extends/systemLogs'));
const TroubleshootingPage = lazy(
  () => import('src/pages/dashboard/administrators/extends/troubleshooting')
);
const MeetingScheduleViewPage = lazy(
  () => import('src/pages/dashboard/manage/calendar/meetingSchedule/list')
);
const MeetingScheduleNewPage = lazy(
  () => import('src/pages/dashboard/manage/calendar/meetingSchedule/create')
);
const TestScheduleViewPage = lazy(
  () => import('src/pages/dashboard/manage/calendar/testSchedule/list')
);
const TestScheduleNewPage = lazy(
  () => import('src/pages/dashboard/manage/calendar/testSchedule/create')
);
const ChartPage = lazy(() => import('src/pages/dashboard/manage/exportReport/Chart'));
const AcademicTransriptPage = lazy(
  () => import('src/pages/dashboard/manage/exportReport/AcademicTranscript')
);
const DetailReportPage = lazy(() => import('src/pages/dashboard/manage/exportReport/DetailReport'));
const WeeklyReportPage = lazy(() => import('src/pages/dashboard/manage/exportReport/WeeklyReport'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));

// client
const LearningProgressClient = lazy(() => import('src/pages/dashboard/clients/learningProgress'));
const MentoringClient = lazy(() => import('src/pages/dashboard/clients/mentoring'));
const CertificateClient = lazy(() => import('src/pages/dashboard/clients/certificate'));
const SettingClient = lazy(() => import('src/pages/dashboard/clients/settings'));
const ContributionClient = lazy(() => import('src/pages/dashboard/clients/contribution'));
const ContributionCreateClient = lazy(
  () => import('src/pages/dashboard/clients/contribution/create')
);
const WishlistClient = lazy(() => import('src/pages/dashboard/clients/wishlist'));
const CalendarScheduleClient = lazy(() => import('src/pages/dashboard/clients/calendar/schedule'));
const CalendarMeetingScheduleClient = lazy(
  () => import('src/pages/dashboard/clients/calendar/meetingSchedule')
);
const CalendarTestScheduleClient = lazy(
  () => import('src/pages/dashboard/clients/calendar/testSchedule')
);
const FileMangePage = lazy(() => import('src/pages/dashboard/manage/fileManage'));

export const manageRoutes = [
  { path: 'learning-progress', element: <LearningProgressClient /> },
  { path: 'file-manager', element: <FileMangePage /> },
  {
    path: 'user',
    children: [
      { element: <UserProfilePage />, index: true },
      { path: 'profile', element: <UserProfilePage /> },
      { path: 'cards', element: <UserCardsPage /> },
      { path: 'list', element: <UserListPage /> },
      { path: 'new', element: <UserCreatePage /> },
      { path: 'excel', element: <UserCreateExcelPage /> },
      { path: ':id/edit', element: <UserEditPage /> },
      { path: 'account', element: <UserAccountPage /> },
      { path: 'location', element: <UserAreas /> },
      { path: 'group', element: <UserGroups /> },
      { path: 'department', element: <UserDepartment /> },
      { path: 'position', element: <UserPosition /> },
    ],
  },
  {
    path: 'course',
    children: [
      { element: <CourseMangePage />, index: true },
      { path: 'list', element: <CourseMangePage /> },
      { path: 'table', element: <CourseMangeTablePage /> },
      { path: 'new', element: <CourseNewPage /> },
      { path: 'assignment-list', element: <AssignmentListPage /> },
      { path: 'add-child-course', element: <AddChildCourse /> },
      { path: 'add-user-to-course', element: <AddUserToCourse /> },
      { path: 'categories', element: <CategoryCoursePage /> },
      { path: 'contribution', element: <ContributionManagePage /> },
    ],
  },
  {
    path: 'order',
    children: [{ element: <OrderManagePage />, index: true }],
  },
  {
    path: 'question',
    children: [
      {
        path: '',
        children: [
          { element: <QuestionListPage />, index: true },
          { path: 'create', element: <QuestionNewPage /> },
          { path: 'create/excel', element: <CreateQuestionByExcel /> },
        ],
      },
      {
        path: 'group',
        children: [
          { element: <GroupsListPage />, index: true },
          { path: 'create', element: <GroupNewPage /> },
        ],
      },
      {
        path: 'exam',
        children: [
          { element: <ExamListPage />, index: true },
          { path: 'create', element: <ExamNewPage /> },
        ],
      },
      {
        path: 'survey',
        children: [
          { element: <SurveyListPage />, index: true },
          { path: 'create', element: <SurveyNewPage /> },
        ],
      },
    ],
  },
  {
    path: 'email',
    children: [
      { element: <EmailViewPage />, index: true },
      { path: 'template', element: <EmailTemplateViewPage /> },
    ],
  },
  {
    path: 'notify',
    children: [
      { element: <NotifyViewPage />, index: true },
      { path: 'new', element: <NotifyNewPage /> },
    ],
  },
  {
    path: 'certificate',
    children: [
      { element: <CertificateViewPage />, index: true },
      { path: 'new', element: <CertificateNewPage /> },
    ],
  },
  {
    path: 'calendar',
    children: [
      {
        path: 'schedule',
        children: [
          { element: <ScheduleViewPage />, index: true },
          { path: 'new', element: <ScheduleNewPage /> },
        ],
      },
      {
        path: 'meeting-schedule',
        children: [
          { element: <MeetingScheduleViewPage />, index: true },
          { path: 'new', element: <MeetingScheduleNewPage /> },
        ],
      },
      {
        path: 'test-schedule',
        children: [
          { element: <TestScheduleViewPage />, index: true },
          { path: 'new', element: <TestScheduleNewPage /> },
        ],
      },
    ],
  },
  {
    path: 'export-report',
    children: [
      { path: 'detail-report', element: <DetailReportPage />, index: true },
      { path: 'weekly-report', element: <WeeklyReportPage /> },
      { path: 'academic-transcript', element: <AcademicTransriptPage /> },
      { path: 'chart', element: <ChartPage /> },
    ],
  },
  { path: 'file', element: <OverviewFilePage /> },
  {
    path: 'chat',
    children: [{ element: <ChatPage />, index: true }],
  },
  {
    path: 'extend',
    children: [
      { path: 'system-access', element: <SystemAccessPage /> },
      { path: 'system-logs', element: <SystemLogsPage /> },
      { path: 'troubleshooting', element: <TroubleshootingPage /> },
    ],
  },
  {
    path: 'news',
    children: [
      { element: <ListNewPage />, index: true },
      { element: <CreateNewPage />, path: 'create' },
    ],
  },
];

export const clientRoutes = [
  { path: 'learning-progress', element: <LearningProgressClient /> },
  { path: 'mentoring', element: <MentoringClient /> },
  { path: 'profile', element: <UserProfilePage /> },
  { path: 'certificate', element: <CertificateClient /> },
  { path: 'setting', element: <SettingClient /> },
  {
    path: 'contribution',
    children: [
      { element: <ContributionClient />, index: true },
      { element: <ContributionCreateClient />, path: 'create' },
    ],
  },
  { path: 'wishlist', element: <WishlistClient /> },
  {
    path: 'chat',
    children: [{ element: <ChatPage />, index: true }],
  },
  {
    path: 'notify',
    children: [{ element: <NotifyPage />, index: true }],
  },
  { path: 'wishlist', element: <WishlistClient /> },
  {
    path: 'calendar',
    children: [
      { element: <CalendarScheduleClient />, index: true },
      { path: 'schedule', element: <CalendarScheduleClient /> },
      { path: 'meeting-schedule', element: <CalendarMeetingScheduleClient /> },
      { path: 'test-schedule', element: <CalendarTestScheduleClient /> },
    ],
  },
];

export const teacherRoutes = [
  ...manageRoutes,
  {
    path: 'contribution',
    children: [
      { element: <ContributionClient />, index: true },
      { element: <ContributionCreateClient />, path: 'create' },
    ],
  },
];
